<template>
  <ul>
    <template v-for="item in items">
      <component
        v-if="checkPerm(item.permission)"
        :is="resolveNavItemComponent(item)"
        :key="item.header || item.title"
        :item="item"
      />
    </template>
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { provide, ref } from "@vue/composition-api";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";
import VerticalNavMenuGroup from "../vertical-nav-menu-group/VerticalNavMenuGroup.vue";
import { getUserData } from "@/auth/utils";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  mounted(){

  },
  methods: {
    ...mapActions('app', ['FETCH_ALL_NOTIFICATIONS', 'FETCH_NOTIFICATIONS_SET_NOTIF']),

    checkPerm(permission) {
      let useData = getUserData();
      let out;
      if (useData && useData.is_superuser) {
        return true;
      }
      for (let i = 0; i < permission?.length; i++) {
        const element = permission[i];
        if (element === "home_all" || useData.role.includes(element)) {
          out = true;
          break;
        }
      }
      return out;
    },

    async goToPlace(notification){

      if(notification.content_type == 'requirement_for_good'){
        this.$router.push(`/applications/material/view/${notification.object_id}`)
        this.refreshViewMaterial = !this.refreshViewMaterial
      }else if(notification.content_type == 'requirement_for_instrument'){
        this.$router.push(`/applications/instrument/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_brigade'){
        this.$router.push(`/applications/works/view/${notification.object_id}`)
      }else if(notification.content_type == 'requirement_for_transport'){
        this.$router.push(`/applications/transport/view/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_good'){
        this.$router.push(`/return/view/material/${notification.object_id}`)
      }else if(notification.content_type == 'return_of_instrument'){
        this.$router.push(`/return/view/instrument/${notification.object_id}`)
      }else if(notification.content_type == 'contract'){
        this.$router.push(`/view-agreements/${notification.object_id}`)
      }

      
      await this.$socket.send(JSON.stringify({pk: notification.id, action: "read_notification", request_id: Date.now()}))
      setTimeout(async () => {
        await this.FETCH_ALL_NOTIFICATIONS({is_read: false})
      }, 500)
    },  

  },
  watch: {
    notifications: {
      handler(newValue, oldValue) {
        if(newValue){
          this.items.forEach((item) => {item.tag = ''})
          newValue.results.forEach((elem) => {



            this.items.forEach((item, index) => {
              if(elem.content_type == 'requirement_for_good' && item.route == "applications-material"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$nextTick()
                this.$forceUpdate();
              }else if(elem.content_type == 'requirement_for_instrument' && item.route == "applications-instrument"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }else if(elem.content_type == 'requirement_for_brigade' && item.route == "applications-works"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }else if(elem.content_type == 'requirement_for_transport' && item.route == "applications-transport"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }else if(elem.content_type == 'return_of_good' && item.route == "return"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }else if(elem.content_type == 'return_of_instrument' && item.route == "return"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }else if(elem.content_type == 'contract' && item.route == "agreements"){
                if(item.tag){
                  this.$set(item, 'tag', item.tag + 1);
                }else{
                  this.$set(item, 'tag', 1);
                }
                this.$forceUpdate();
              }
            })


         

          })
        }
      },
      deep: true,
    }
  },
  computed:{
    ...mapState('app', ['notifications']),
    refreshViewMaterial: {
      get: function () {
        return this.$store.state.agrements.refreshViewMaterial;
      },
      set: function (newValue) {
        this.$store.commit('application/SET_REFRESH_VIEW_MATERIAL', newValue)
      }
    },
    notificationsReadTotal(){
      let total = 0;
      if(this.notifications && this.notifications.results && this.notifications.results.length > 0){
        this.notifications.results.forEach((elem) => {
          if(elem.is_read == false){
            total++;
          }
        })
      }
      return total
    }
  },
  setup(props) {
    provide("openGroups", ref([]));
    return {
      resolveNavItemComponent,
    };
  },
};
</script>
